import { Layers } from "appworks/graphics/layers/layers";
import { Sprite } from "appworks/graphics/pixi/sprite";
import { Point } from "appworks/utils/geom/point";
import { Graphics } from "pixi.js";
import { LinesComponent, LinesComponentConfig } from "slotworks/components/lines/lines-component";

export class DMFLinesComponent extends LinesComponent {

    constructor(protected lineDefinitions: Point[][], config?: LinesComponentConfig) {
        super(lineDefinitions, config);
    }

    public draw(lineDefinitions: Point[][]) {
        if (this.lines && this.lines.length) {
            for (const line of this.lines) {
                if (line instanceof Graphics) {
                    line.clear();
                }

                Layers.get("Paylines").remove(line);
            }
        }

        this.lines = [];
        this.highlightLines = [];

        for (let lineIndex = 0; lineIndex < lineDefinitions.length; lineIndex++) {
            const lineDefinition = lineDefinitions[lineIndex];

            let line: Graphics | Sprite;
            let highlightLine: Graphics | Sprite;

            const lineSprite = Layers.get("Paylines").getSprite("line_" + (lineIndex + 1));
            let highlightLineSprite = Layers.get("Paylines").getSprite("highlight_line_" + (lineIndex + 1));

            if (!highlightLineSprite) {
                highlightLineSprite = lineSprite;
            }

            if (lineSprite) {
                // Graphical lines (assetworks)
                line = lineSprite;
                highlightLine = highlightLineSprite;

                if (LinesComponent.lineFlips.has(lineIndex)) {
                    this.flip(lineIndex, line);
                    if (line !== highlightLine) {
                        this.flip(lineIndex, highlightLine);
                    }
                }
            } else {
                // Draw them ourselves
                if (LinesComponent.DRAW_LINES) {
                    line = this.drawLine(lineDefinition, 18, 0x00aa00, 0.2);
                    this.drawLine(lineDefinition, 15, 0x00aa00, 0.4, line);
                    this.drawLine(lineDefinition, 12, 0x00aa00, 0.6, line);
                    this.drawLine(lineDefinition, 3, 0xffffff, 1, line);
                } else {
                    line = new Graphics();
                }

                highlightLine = line;
            }

            line.visible = false;
            highlightLine.visible = false;

            this.lines.push(line);
            this.highlightLines.push(highlightLine);

            Layers.get("Paylines").add(line);
            Layers.get("Paylines").add(highlightLine);
        }

        this.drawPips(lineDefinitions);
    }
}
